export default __webpack_public_path__ + "static/media/pagcor-cert.df65042e.webp";